module.exports = __webpack_public_path__ + "img/iPhone_picture.7d388b87.jpg";